var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.854 16.75a.876.876 0 010 1.75.876.876 0 010-1.75zM11.876 6.25c2.065 0 3.749 1.649 3.749 3.68 0 1.753-1.214 3.208-2.924 3.579v1.144a.843.843 0 01-.836.847.843.843 0 01-.837-.847v-1.89c0-.45.35-.821.792-.846h.056c.067 0 .134-.003.2-.01 1.074-.098 1.876-.952 1.876-1.976 0-1.09-.926-1.987-2.076-1.987-.494 0-.974.17-1.35.477-.238.196-.43.444-.555.717a.836.836 0 01-.475.441v.001a.836.836 0 01-.639-.028V9.55a.856.856 0 01-.406-1.122 3.73 3.73 0 011.023-1.325 3.796 3.796 0 012.402-.854z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 1.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17z",
    fill: "currentColor"
  })));
}
SvgHelp.displayName = 'Help';
export default SvgHelp;